export default __webpack_public_path__ + "static/media/nano-logo.5c8d9de0.png";